<script setup lang="ts">
import type { DescriptionListDetailedItem } from './types'
import { VButton } from '@/modules/shared/components'

defineProps<{
  items: DescriptionListDetailedItem[]
}>()

defineEmits<{
  'action-click': [item: DescriptionListDetailedItem]
}>()
</script>

<template>
  <div data-component="VDescriptionListDetailed" class="divide-y divide-[var(--divider-color,#EEEFF0)]">
    <div v-for="item in items" :key="item.label" class="flex items-center gap-3 py-2.5">
      <div
        class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full"
        :style="{ backgroundColor: item.color + '1A' }"
      >
        <component :is="item.icon" :size="18" :style="{ color: item.color }" />
      </div>
      <div class="flex-1">
        <div class="text-sm font-semibold text-gray-700">{{ item.label }}</div>
        <div v-if="item.sublabel" class="text-xs text-gray-500">{{ item.sublabel }}</div>
      </div>
      <div class="min-w-[4.5rem] text-right text-lg font-semibold" :style="{ color: item.color }">{{ item.value }}</div>
      <VButton
        v-if="item.actionLabel"
        size="xs"
        :variant="item.actionVariant || 'secondary'"
        class="ml-auto"
        @click="$emit('action-click', item)"
      >
        {{ item.actionLabel }}
      </VButton>
    </div>
  </div>
</template>
